<template>
    <div class="rel {transform:rotate(180deg)}>.show>i">
        <div class="form-control d:flex! ai:center" data-bs-toggle="dropdown" ref="container" v-bind="$attrs">
            <div class="text:ellipsis white-space:nowrap overflow:hidden" v-if="values.length">{{ title }}</div>
            <div class="color:#A9A9A9" v-else>{{ placeholder }}</div>
            <i class="fa-solid fa-angle-down f:14 ml:auto"></i>
        </div>
        <div @click.stop class="
            dropdown-menu w:full max-h:242 overflow:auto
            {d:flex}_.item
            {bg:#EDF5FF}_.item:hover
            {p:18|15;lh:1}_.item>*
            {m:0|8|0|0}_input
            {b:#538BD4;shadow:0|0|0|2|#538BD433}_input:hover
            {transform:rotate(180deg)}_.handler:where(.collapsed)>i
        ">
            <div class="p:0|15|8 flex ai:center jc:space-between" v-if="limit > 1">
                <div class="color:#538BD4 f:16 lh:24px">
                    已選擇 {{ list.length }}/{{ limit }}
                </div>
                <button
                    class="b:1|solid|#CECECE color:#6F737D {b:#538BD4;color:#538BD4}:hover font-weight:700 f:14 lh:20px r:8 p:8|12 {bg:#CECECE;opacity:0.5}:disabled"
                    @click="clean"
                    :disabled="!list.length"
                    type="button"
                >
                    <i class="fa-solid fa-xmark f:14 mr:8"></i>
                    清除全部
                </button>
            </div>
            <template :key="item.no" v-for="(item) in items">
                <template v-if="item.n?.length">
                    <div class="item">
                        <label>
                            <input
                                class="form-check-input"
                                @click="change(item)"
                                :disabled="disabled(item)"
                                :id="`${name}-${item.no}`"
                                :indeterminate="indeterminate(item)"
                                type="checkbox"
                                :value="item.no"
                                v-if="limit > 1 && checkGroup"
                                v-model="values"
                            />
                            {{ item.des }}
                        </label>
                        <div class="flex:1 text:right mr:1 handler collapsed" :data-bs-target="`#collapse-${name}-${item.no}`" data-bs-toggle="collapse">
                            <i class="fa-solid fa-angle-up f:14"></i>
                        </div>
                    </div>
                    <div class="collapse" :id="`collapse-${name}-${item.no}`">
                        <template :key="item2.no" v-for="(item2) in item.n">
                            <template v-if="item2.n?.length">
                                <div class="item">
                                    <label class="pl:45!">
                                        <input
                                            class="form-check-input"
                                            @click="change(item2, item)"
                                            :disabled="disabled(item2)"
                                            :id="`${name}-${item2.no}`"
                                            :indeterminate="indeterminate(item2)"
                                            type="checkbox"
                                            :value="item2.no"
                                            v-if="limit > 1 && checkGroup"
                                            v-model="values"
                                        />
                                        {{ item2.des }}
                                    </label>
                                    <div class="flex:1 text:right mr:1 handler collapsed" :data-bs-target="`#collapse-${name}-${item2.no}`" data-bs-toggle="collapse">
                                        <i class="fa-solid fa-angle-up f:14"></i>
                                    </div>
                                </div>
                                <div class="collapse" :id="`collapse-${name}-${item2.no}`">
                                    <div class="item" :key="item3.no" v-for="(item3) in item2.n">
                                        <label class="flex:1 pl:75!">
                                            <input
                                                class="form-check-input"
                                                @click="change(item3, item2, item)"
                                                :disabled="disabled(item3)"
                                                :id="`${name}-${item3.no}`"
                                                type="checkbox"
                                                :value="item3.no"
                                                v-model="values"
                                            />
                                            {{ item3.des }}
                                        </label>
                                    </div>
                                </div>
                            </template>
                            <div class="item" v-else>
                                <label class="flex:1 pl:45!">
                                    <input
                                        class="form-check-input"
                                        @click="change(item2, item)"
                                        :disabled="disabled(item2)"
                                        :id="`${name}-${item2.no}`"
                                        type="checkbox"
                                        :value="item2.no"
                                        v-model="values"
                                    />
                                    {{ item2.des }}
                                </label>
                            </div>
                        </template>
                    </div>
                </template>
                <div class="item" v-else>
                    <label class="flex:1">
                        <input
                            class="form-check-input"
                            @click="change(item)"
                            :disabled="disabled(item)"
                            :id="`${name}-${item.no}`"
                            type="checkbox"
                            :value="item.no"
                            v-model="values"
                        />
                        {{ item.des }}
                    </label>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
    import { items, mapping, toString } from "../options/job-category";

    const props = defineProps({
        checkGroup: { default: false, type: Boolean },
        limit: { default: 1, type: Number },
        modelValue: { type: String },
        name: { required: true, type: String },
        placeholder: { default: "請選擇", type: String }
    });

    const container = ref();

    const list = computed(() => {
        return values.value.filter((id) => {
            if (id % 100 && has(`${parseInt(id / 100)}00`)) {
                return false;
            }
            if (id % 10000 && has(`${parseInt(id / 10000)}0000`)) {
                return false;
            }
            return true;
        });
    });

    const title = computed(() => list.value.map(toString).join("、"));

    const values = ref([]);

    const add = (id) => {
        if (!values.value.includes(id)) {
            values.value.push(id);
        }
    };

    const change = (me, parent, grandparent) => {
        if (props.limit > 1 && props.checkGroup) {
            setTimeout(() => {
                const func = has(me.no) ? add : remove;
                me.n?.forEach((son) => {
                    func(son.no);
                    son.n?.forEach((grandson) => func(grandson.no));
                });
                [parent, grandparent].forEach((target) => {
                    if (target) {
                        const checked = target.n.filter((item) => has(item.no)).length;
                        if (checked === target.n.length) {
                            add(target.no);
                        } else {
                            remove(target.no);
                        }
                    }
                });
            });
        }
    };

    const clean = () => {
        values.value.length = 0;
    };

    const disabled = (item) => {
        if (props.limit > 1) {
            if (has(item.no)) {
                if (!item.no.endsWith("0000")) {
                    const parentId = item.no.endsWith("00") ? (parseInt(item.no / 10000) * 10000) : (parseInt(item.no / 100) * 100);

                    if (has(`${parentId}`)) {
                        if (list.value.length + mapping[parentId].n.length - 2 > props.limit) {
                            return true;
                        }
                    }
                }
            } else {
                let count = 0;

                if (item.no.endsWith("0000")) {
                    if (!item.n.some((son) => has(son.no) || son.n?.some((grandson) => has(grandson.no)))) {
                        count = 1;
                    }
                } else if (item.no.endsWith("00")) {
                    if (!item.n.some((son) => has(son.no))) {
                        const siblings = mapping[parseInt(item.no / 10000) * 10000]?.n;

                        if (!siblings || siblings.length === 1 || siblings.filter((sibling) => has(sibling.no)).length + 1 < siblings.length) {
                            count = 1;
                        }
                    }
                } else {
                    const siblings = mapping[parseInt(item.no / 100) * 100]?.n;

                    if (!props.checkGroup || siblings.length === 1 || siblings.filter((sibling) => has(sibling.no)).length + 1 < siblings.length) {
                        count = 1;
                    }
                }

                if (list.value.length + count > props.limit) {
                    return true;
                }
            }
        }

        return false;
    };

    const emit = defineEmits(["update:modelValue"]);

    const has = (id) => values.value.includes(id);

    const indeterminate = (item) => {
        if (!has(item.no) && item.n.some((son) => has(son.no) || son.n?.some((grandson) => has(grandson.no)))) {
            return true;
        } else {
            return false;
        }
    };

    const remove = (id) => {
        const index = values.value.indexOf(id);

        if (index >= 0) {
            values.value.splice(index, 1);
        }
    };

    if (props.modelValue) {
        onMounted(() => {
            props.modelValue.toString().split(",").forEach((id) => {
                const parentId = id % 100 ? parseInt(id / 100) * 100 : null;
                const grandparentId = id % 10000 ? parseInt(id / 10000) * 10000 : null;

                add(id);
                change(mapping[id], mapping[parentId], mapping[grandparentId]);
            });
        });
    }

    defineOptions({ inheritAttrs: false });

    watch(values, () => {
        if (props.limit === 1) {
            while (values.value.length > 1) {
                values.value.shift();
            }

            bootstrap.Dropdown.getInstance(container.value)?.hide();
        }

        emit("update:modelValue", list.value.join(","));
    }, { deep: true });
</script>
